// extracted by mini-css-extract-plugin
export default {"tabs-group":"tabs-group_tabs-group__w1099"};